
import TaMoAkiLogo from '@/components/branding/TaMoAkiLogo';
import { NotificationBell } from '@/components/quick-wins';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { Menu } from 'lucide-react';
import { useState } from 'react';
import DrawerMenu from './DrawerMenu';

const MainHeader = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { user } = useAuth();

  return (
    <>
      <header role="banner" className="bg-white shadow-sm border-b px-4 py-3 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsDrawerOpen(true)}
            className="p-2"
            aria-label="Abrir menu de navegação"
            aria-expanded={isDrawerOpen}
            aria-controls="drawer-menu"
          >
            <Menu className="w-6 h-6 text-gray-700" aria-hidden="true" />
          </Button>
          
          <TaMoAkiLogo size="md" showText={true} />
        </div>

        {/* Quick Wins - Componentes do Header */}
        {/* ThemeToggle ocultado: dark mode incompleto (ver Sidebar). */}
        <div className="flex items-center space-x-2">
          {user && <NotificationBell />}
        </div>
      </header>

      <DrawerMenu 
        id="drawer-menu"
        isOpen={isDrawerOpen} 
        onClose={() => setIsDrawerOpen(false)} 
      />
    </>
  );
};

export default MainHeader;
